import * as _ from "lodash";
import * as React from "react";

import { TYPE_CUSTOMERS } from "../../../Constants";
import { isNavigationItemHidden } from "../../../Helpers/appState";
import { DetailBaseData, StateRoot } from "../../../Models";
import NavigationTextArea from "./NavigationTextArea";
import { isMetsoData } from "../../../Helpers/source";
import { isBuildType } from "../../../Helpers/build";

interface NavigationItemProps {
    level: number;
    navigationItem: DetailBaseData;
    navigationItems: DetailBaseData[];
    filter: string;
    isModalSelectionMode: boolean;

    navigationItemSelected(
        node: DetailBaseData,
        shouldCloseMobileMenu?: boolean
    ): void;
}

const NavigationItem: React.FC<NavigationItemProps> = (
    props: NavigationItemProps
) => {
    const isMetso: boolean = isMetsoData(props.navigationItem);

    const onToggleLevel: () => void = (): void => {
        props.navigationItemSelected(props.navigationItem);
    };

    const getAllChildrenBaseItems: () => DetailBaseData[] =
        (): DetailBaseData[] => {
            if (props.level > 0) {
                return props.navigationItems;
            }

            const baseItems: DetailBaseData[] = _.filter(
                props.navigationItems,
                (item: DetailBaseData) => {
                    return item.country === props.navigationItem.country;
                }
            );

            return baseItems;
        };

    const getImmediateChildren: () => DetailBaseData[] =
        (): DetailBaseData[] => {
            let children: DetailBaseData[] = _.filter(
                getAllChildrenBaseItems(),
                (item: DetailBaseData) => {
                    if (item.parent === null || item.parent === undefined) {
                        return false;
                    }
                    return (
                        item.description &&
                        item.parent === props.navigationItem.id
                    );
                }
            );

            return _.sortBy(children, (c: DetailBaseData) =>
                c.description.toLowerCase()
            );
        };

    const getItemClass: (isSelected: boolean) => string = (
        isSelected: boolean
    ): string => {
        let itemClass: string = "NavigationTree__item";

        if (props.navigationItem.type === TYPE_CUSTOMERS) {
            itemClass = `${itemClass} NavigationTree__item--root ${
                (isSelected && "NavigationTree__item--active") || ""
            }`;
        } else {
            itemClass =
                props.level === 0
                    ? `${itemClass} NavigationTree__item--root NavigationTree__item--rootSiteProduct ${
                          (isSelected && "NavigationTree__item--active") || ""
                      }`
                    : `${itemClass} NavigationTree__item--children ${
                          (isSelected && "NavigationTree__item--active") || ""
                      }`;
        }

        if (isMetso) {
            itemClass = `${itemClass} NavigationTree__item--metso`;
        }

        return itemClass;
    };

    const showChildrens: string = props.navigationItem.showChildren
        ? "inline"
        : "none";
    const immediateChildren: DetailBaseData[] = getImmediateChildren();
    const allChildren: DetailBaseData[] = getAllChildrenBaseItems();

    const isSelected: boolean = props.navigationItem.active;
    const isModalSelectionMode: boolean = props.isModalSelectionMode;
    const itemClass: string = getItemClass(isSelected);
    const hasChildren: boolean =
        props.navigationItem.hasChildren ||
        (props.level === 0 && props.navigationItem.type !== TYPE_CUSTOMERS);
    const childLevel: number = props.level + 1;

    return (
        <li
            onClick={(e) => {
                e.stopPropagation();
                props.navigationItemSelected(props.navigationItem, true);
            }}
        >
            {
                <NavigationTextArea
                    isMetso={isMetso}
                    itemClass={itemClass}
                    level={props.level}
                    type={props.navigationItem.type}
                    description={props.navigationItem.description}
                    isOpen={props.navigationItem.showChildren}
                    hasChildren={hasChildren}
                    state={props.navigationItem.state}
                    onToggleLevel={onToggleLevel}
                />
            }
            <ul style={{ display: showChildrens }}>
                {_.map(immediateChildren, (node: DetailBaseData) => {
                    if (isNavigationItemHidden(node)) {
                        return;
                    }
                    if (
                        isModalSelectionMode &&
                        (isBuildType(node.type) || node.type === "Equipment")
                    ) {
                        return;
                    }

                    return (
                        <div key={node.id}>
                            {
                                <NavigationItem
                                    navigationItem={node}
                                    navigationItems={allChildren}
                                    filter={props.filter}
                                    level={childLevel}
                                    isModalSelectionMode={isModalSelectionMode}
                                    navigationItemSelected={
                                        props.navigationItemSelected
                                    }
                                />
                            }
                        </div>
                    );
                })}
            </ul>
        </li>
    );
};

export default NavigationItem;
